'use_strict';

(function defCurrent(global) {

  /**
   * Предоставляет текущую открытую часть веб-доступа.
   * В зависимости от текущего контекста пространство имен WebAccess.сurrent
   * может содержать различную информацию.
   * Например, на страницах проводника WebAccess.сurrent предоставляет
   * функции для работы с панелью действий.
   * На страницах задачи оно также включает
   * подробную информацию о текущей задаче и имеет атрибуты
   * Subject, AuthorID, WorkflowBlockID и прочие.
   * @namespace WebAccess.current
   */

  var Current = BaseObject.extend([ global.mixins.formMixin ], {

    /**
     * Предоставляет информацию о текущем пользователе.
     *
     * @namespace WebAccess.current.user
     * @property {integer} ID ИД пользователя
     * @property {string} fullName Полное имя пользователя
     * @property {string} name Имя пользователя
     * @property {string} login Логин пользователя
     * @property {string} organization Организация, в которую входит пользователь
     * @property {string} defaultCertificate Сертификат пользователя
     * @since 5.0.0.7200

     * @example
     * if (WA.CR.user.login == "Administrator") { alert("Добро пожаловать, Администратор"); }
     */
    user: null,
    serviceURL: '/CardForm.asmx',
    containerSelector: 'form.master',
    className: 'Current',

    _detailsGridInit: null,
    _containerInit: null,
    _sideBarContainerSelector: '#left_column',
    _onPopupListeners: null,

    init(formData) {
      this._preInit();
      this._super();
      this._containerInit = $.Deferred();

      $('document').ready(this._containerInit.resolve);

      this._detailsGridInit = WA._DetailsGridInit;

      $.when(global._userInfoInit).done((user) => {
        if (user) {
          this.user = {
            ID: user.ID,
            fullName: user.FullName,
            login: user.Login,
            name: user.Name,
            organization: user.Organization,
            defaultCertificate: user.DefaultCertificate,
            hasComponentFullAccess: user.HasComponentFullAccess,
            hasObjectFullAccess: user.HasObjectFullAccess,
            hasObjectViewAccess: user.HasObjectViewAccess,
            hasESDExportCapability: user.HasESDExportCapability,
            hasDisableDocumentTextAccess: user.HasDisableDocumentTextAccess,
            hasConfigureAccessRightsToFolderContents: user.HasConfigureAccessRightsToFolderContents
          };
        } else {
          this.user = {};
        }

        global.UserInfoInit.resolve();
      });

      this._postInit();

      $.when(this.states.details).then(() => {
        WA.DetailsInit.resolve();
      });

      $.when(this.states.tables, this.states.links, this.states.buttons, this.states.form).then(() => {
        WA.FormInit.resolve();
        WA.FormControlsInit.resolve();
      });

      $.when(this.states.toolBarButtons, this.states.toolBarGroups).then(() => {
        WA.ToolBarInit.resolve();
      });

      $.when(this.states.tabs).then(() => {
        WA.SideBarInit.resolve();
      });

      $.when(this.states.objectList).then(() => {
        WA.ObjectListInit.resolve();
      });

      this.folderTree = new global.components.wrappers.folderTree.FolderTree(WA.FolderTreeInit);

      this._onPopupListeners = [];

      // Добавить обработчик переходов по вкладкам
      window.onpopstate = (ev) => {
        this._onPopupListeners.forEach((callback) => {
          callback(ev);
        });
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Инициализировать objectList.
     *
     * @private
     * @method WebAccess.Current#_initObjectList
     */
    _initObjectList: function () {
      var me = this;
      var WR = global.CMP.wrappers;
      var isTable = WA.getLocation() === 'referencerecords'; //TODO придумать нормальную проверку, но тут еще грид не проинициализирован.
      if (isTable) {
        me.objectList = new WR.objectList.ObjectsTable(me.containerSelector);
      } else {
        me.objectList = new WR.objectList.FolderList(me.containerSelector);
      }
    },

    /**
     * Получает ссылку на текущий объект.
     *
     * @private
     * @method WebAccess.Current#_getObjectLink
     * @return {object} Модель ссылки.
     */
    _getObjectLink: function () {
      var link = new WA.Link();
      if (link.type) {
        return $.toJSON(link.toLinkModel());
      } else {
        return '';
      }
    },

    /**
     * Получает наименование представления текущего объекта.
     *
     * @private
     * @method WebAccess.Current#_getObjectView
     * @return {string} Наименование представления текущего объекта.
     */
    _getObjectView: function () {
      return WA.CR.getReferenceView();
    },

    /**
     * Получает данные формы.
     *
     * @private
     * @method WebAccess.Current#_getFormData
     * @return {object} Данные формы.
     */
    _getFormData: function () {
      return window.formData;
    },

    /**
     * Получает детальные разделы.
     *
     * @private
     * @method WebAccess.Current#_getGrids
     * @return {object} Ассоциативный массив детальных разделов.
     */
    _getGrids: function () {
      return Core.grid.details;
    },

    /**
     * Получает идентификатор текущего объекта.
     *
     * @method WebAccess.current#getID
     * @return {string} ИД текущего объекта.
     */
    getID: function () {
      var me = this;
      // Для проводника всегда получаем из URL, т.к. он может измениться.
      if (!!me.ID) return me.ID;
      var recID = recID = parseInt(GetParamInURL("id"), 10);
      if (!isNaN(recID)) {
        me.ID = recID;
        return recID;
      }
      return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
     * Получает имя текущего справочника.
     *
     * @method WebAccess.current#getReferenceCode
     * @return {string} Имя текущего справочника; иначе возвращает null.
     */
    getReferenceCode: function () {
      var me = this;
      if (me.ReferenceCode) return me.ReferenceCode;
      var refName = unescape(GetParamInURL("compcode"));
      if (typeof refName !== 'undefined') {
        me.ReferenceCode = refName;
        return refName;
      }
      else {
        refName = unescape($("#RefCode").val());
        if (typeof refName !== 'undefined') {
          me.ReferenceCode = refName;
          return refName;
        }
      }
      return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает имя текущего представления справочника.
     *
     * @method WebAccess.current#getReferenceView
     * @return {string} Имя текущего представления справочника.
     */
    getReferenceView: function () {
      var me = this;
      if (typeof me.ReferenceView !== 'undefined') return me.ReferenceView;
      var refView = GetParamInURL("refview");
      if (typeof refView !== 'undefined') {
        me.ReferenceView = refView;
        return refView;
      }
      return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает тип текущего объекта.
     *
     * @method WebAccess.current#getKind
     * @return {string} Cтроковое представление типов объекта: "fol", "edoc", "task", "job", "ref".
     * @since 5.0.0.4200
     */
    getKind: function () {
      var me = this;
      if (typeof me.Type !== 'undefined' && me.Type !== null) {
        var type = me.Type;
        var typesKinds = { 0: 'FOL', 1: 'EDOC', 2: 'TASK', 3: 'JOB', 9: 'REF' };
        return typesKinds[ type ] || null;
      } else {
        switch (global.getLocation()) {
          case 'explorer':
          case 'folder':
            return 'FOL';
          case 'doc':
            return 'EDOC';
          case 'job':
            return 'JOB';
          case 'task':
            return 'TASK';
          default:
            return null;
        }
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает тип текущего объекта.
     *
     * @method WebAccess.current#getObjectType
     * @return {OBJECT_TYPE} Тип объекта.
     * @since 5.0.0.4200
     *
     * @example
     * if (WebAccess.current.getObjectType() === OBJECT_TYPE.JOB) {
     *   alert('Открыта карточка задания');
     * }
     */
    getObjectType: function () {
      var me = this;
      return objectKindToObjectType(me.getKind());
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Инициализирует модель панели "Создать".
     *
     * @method WebAccess.current#initCreatePanel
     * @param {object} model Модель панели "Создать", передается от модели родительской компоненты.
     * @since 5.5.0
     */
    initCreatePanel: function (model) {
      this.createPanel = new WA.components.CreatePanel(model);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Инициализирует модель верхней части проводника.
     *
     * @method WebAccess.current#initHeader
     * @param {string} containerId ИД элемента страницы, в который будет помещен сгенерированный HTML-элемент верхней части проводника.
     * @param {object} model Модель верхней части проводника, передаваемая из сгенерированного HTML-элемента верхней части проводника.
     * @since 5.5.0
     */
    initHeader: function (containerId, model) {
      this.initCreatePanel(model.createPanelData);
      this.header = new WA.components.Header(containerId, model, [ this.createPanel ]);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Инициализация и отрисовка реактивного тулбара.
     *
     * @method initToolbar
     * @param {string} containerId ИД контейнера, куда необходимо отрисовать компоненту.
     * @param {object} model Модель тулбара.
     */
    initToolbar(containerId, model) {
      const _renderToolbar = (containerId, model) => {
        $.when(WA.Init).then(() => {
          ReactDOM.render(
            React.createElement(Component.Toolbar, model),
            document.getElementById(containerId),
          );
        });
      };

      model.extended = {
        restore: () => {
          WA.CMP.wrappers.toolBar.ReactToolBar.toolbarRestore(
            model,
            () => _renderToolbar(containerId, model),
          );
        },
        collapseOneButton: () => {
          WA.CMP.wrappers.toolBar.ReactToolBar.toolbarCollapseOneButton(
            model,
            () => _renderToolbar(containerId, model),
          );
        },
      };

      // Если ранее тулбар был скрыт, продолжаем скрывать его
      if (this.toolBar) {
        model.isHidden = this.toolBar.getIsHidden();
      }
      this.toolBar = new WA.CMP.wrappers.toolBar.ReactToolBar(model);
      this.toolBar.bind(WA.CMP.wrappers.toolBar.ReactToolBar.EVENT.CHANGE_STATE, () => {
        _renderToolbar(containerId, model);
      });

      _renderToolbar(containerId, model);
      $('html').trigger(PAGE_EVENTS.TOOLBAR_GROUPS_INIT_DONE);
      $('html').trigger(PAGE_EVENTS.TOOLBAR_BUTTONS_INIT_DONE);
    },

    /**
     * Инициализация элемента шапки.
     *
     * @method initCardHeader
     * @param {object} headerDomElement Dom-элемент контейнера, в который производится отрисовка.
     * @param {object} model Модель шапки.
     */
    initCardHeader(headerDomElement, model) {
      ReactDOM.render(
        React.createElement(Component.CardHeader, model),
        headerDomElement,
      );
      document.title = model.title;
    },

    /**
     * Добавляет callback-функцию для обработки переходов по истории браузера.
     *
     * @method WebAccess.current#addOnPopupListener
     * @param {function} callback Callback-функция.
     */
    addOnPopupListener: function (callback) {
      this._onPopupListeners.push(callback);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Инициализирует или обновляет модель закладки карточки объекта.
     *
     * @method WebAccess.current#initOrUpdateCardTab
     * @param {object} model - Модель закладки карточки, передаваемая из сгенерированного HTML-элемента закладки карточки.
     * @param {string} [containerId = right_column] - ИД элемента страницы, в который помещается сгенерированный HTML-элемент закладки карточки.
     * @since 5.6.0
     */
    initOrUpdateCardTab(model, containerId = 'right_column') {
      // Обновим информацию об объекте в js api
      const objectModel = model.objectModel;
      switch (objectModel.Type) {
        case OBJECT_TYPE.TASK:
          WA.Task = new TaskModel(objectModel);
          WA.CR = Object.assign(WA.CR, WA.Task);
          break;
        case OBJECT_TYPE.JOB:
          WA.Job = new JobModel(objectModel);
          WA.CR = Object.assign(WA.CR, WA.Job);
          break;
      }

      // Если CardTab уже проинициализирован просто обновляем модель
      if (WA.CR.CardTab) {
        WA.CR.CardTab.updateModel(model);
        return;
      }

      // Записываем состояние в историю браузера
      history.replaceState({
        title: document.title,
        url: window.location.href,
        model: {
          type: model.type,
        },
      }, document.title, window.location.href);

      // Функция инициализации дочерних API-компонент
      let initCardTabChildren = (model) => {
        model.inlineHint = model.inlineHint || {};
        this.toolBar = new WA.CMP.wrappers.toolBar.ReactToolBar(model.toolbar);
        this.inlineHint = new WA.CMP.notifications.ReactInlineHint(model.inlineHint);

        // Вызов этих событий оставлен для совместимости с предыдущими версиями.
        // Также эти события участвуют в пробросе для WA.Init.done, чтобы прикладная разработка
        // могла использовать WA.ready(...)
        $('html').trigger(PAGE_EVENTS.TOOLBAR_GROUPS_INIT_DONE);
        $('html').trigger(PAGE_EVENTS.TOOLBAR_BUTTONS_INIT_DONE);
      };

      initCardTabChildren(model);
      this.CardTab = new WA.components.CardTab(containerId, model, [ WA.CR.toolBar, WA.CR.inlineHint ]);
      this.spinner = new WA.CMP.notifications.Spinner();

      // Байндимся на это событие, чтобы переинициализировать дочерние API-компоненты.
      // Это делается до рендера react-компонент, так как при инициализации reactToolbarButton форматируются их модели.
      this.CardTab.bind(PAGE_EVENTS.TAB_ON_BEFORE_RENDER_NEW_MODEL, (cardTabModel) => {
        initCardTabChildren(cardTabModel);
        this.CardTab.unbindChildEvents().bindChildEvents([ this.toolBar, this.inlineHint ]);
      });

      // Добавить обработку события перехода по кнопке Назад в браузере
      this.addOnPopupListener((event) => {
        if (event.state && event.state.model) {
          const tabName = this._getTabName(event.state.model.type);
          this._selectCardTab(tabName);
          this.openReactTab(event.state.model.type, true);
        }
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает доступную высоту.
     *
     * @method WebAccess.current#_getAvailableHeight
     * @private
     * @return {number} Доступная высота в px.
     */
    _getAvailableHeight() {
      return windowHeight() - $(this._sideBarContainerSelector).offset().top;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает содержимое React-закладки карточки объекта.
     *
     * @method WebAccess.current#openReactTab
     * @param {TAB_TYPE} tabType Тип закладки.
     * @param {boolean} forceReload Признак того, что переход на закладку не запишется в историю браузера.
     */
    openReactTab(tabType, forceReload) {
      const tabName = this._getTabName(tabType);
      
      // Переопределить контекстную справку.
      const tabElement = WA.CR.sideBar.tabs[ tabName ];
      if (tabElement.helpLink) {
        const currentHelpLinks = JSON.parse(tabElement.helpLink.replace(/\'/g, '"'))
        BindHelpIcoClick(currentHelpLinks);
      }

      if (!tabElement.isSelected() || forceReload) {

        let deferred = new Promise((resolve) => {
          if (forceReload) {
            resolve();
          } else {
            let jHtml = $('html').trigger(PAGE_EVENTS.ON_BEFORE_TAB_CHANGE)[ 0 ];
            let isModifiedByUser = jHtml.isModifiedByUser;
            if (isModifiedByUser) {              
              ConfirmDialogNew(L('UNSAVED_CHANGES_WILL_BE_LOST'), () => {
                resolve();
              });
            } else {
              resolve();
            }
          }
        });

        deferred.then(() => {
          const url = (new WA.URL());
          let tabsToEnable = [];
          // Сделать сайдбар недоступным для нажатия
          WA.CR.sideBar.tabs.toArray().forEach((tab) => {
            if (tab.isEnabled()) {
              tabsToEnable.push(tab);
              tab.disable();
            }
          });

          const mode = url.getParam('mode');
          let serviceUrl;
          let params;
          switch (tabType) {
            case TAB_TYPE.TASK_CARD:
              serviceUrl = '/api/CardForm.asmx/GetTaskCardTab';
              params = {
                id: WA.CR.ID,
                mode: mode || 'read'
              };
              break;
            case TAB_TYPE.JOB_CARD:
              serviceUrl = '/api/CardForm.asmx/GetJobCardTab';
              params = {
                id: WA.CR.ID,
                mode: mode || 'read',
                folderId: url.getParam('opener') || -1
              };
              break;
            default:
              serviceUrl = '/api/CardForm.asmx/GetTab';
              params = {
                type: WA.CR.Type,
                id: WA.CR.ID,
                tabType: tabType,
                referenceName: WA.CR.ReferenceCode
              };
          }

          // Отправить запрос на сервер
          WA.SRV.call(serviceUrl, params).done((model) => {
            const parsedModel = JSON.parse(model) || {};

            // Изменить url и записать переход в историю
            if (history.pushState && !forceReload) {
              url.setParam('view', tabName);
              history.pushState({
                title: document.title,
                url: url.asString(),
                model: {
                  type: parsedModel.type,
                },
              }, document.title, url.asString());
            }

            // почистим ватермарку
            $('.page-image').remove();

            // TODO: попробовать убрать, когда вольём "Избавление от пересчёта высоты" в develop
            // для устранения дефекта, когда контент "уезжает" вверх при переключении вкладок, прячем #right_column
            // после переключения на вкладку -- распрячиваем (см. на 6 строк ниже).
            $('#right_column').hide();

            // Обновить содержимое вкладки
            WA.CR.initOrUpdateCardTab(parsedModel);
            this._selectCardTab(tabName);
            $('#right_column').show();
            window.setRealHeightAndWidth();
          }).always(() => {
            // Всегда разблокировать сайдбар вне зависимости от результата
            for (const tab of tabsToEnable) {
              tab.enable();
            }
          });
        });
      }
    },

    /**
     * Получает наименование закладки по типу.
     *
     * @private
     * @method WebAccess.current#_getTabName
     * @param {TAB_TYPE} tabType Тип закладки.
     * @returns {string} Наименование закладки.
     */
    _getTabName(tabType) {
      switch (tabType) {
        case TAB_TYPE.JOB_CARD:
        case TAB_TYPE.TASK_CARD:
          return 'Card';
        case TAB_TYPE.CUSTOM_WORK_STATE:
          return 'State';
        case TAB_TYPE.HISTORY:
          return 'History';
        case TAB_TYPE.RIGHTS:
          return 'RightsList';
        case TAB_TYPE.ROUTE_SCHEME:
          return 'OpenRouteSchema';
        case TAB_TYPE.VERSIONS:
          return 'ShowVerList';
      }
      return '';
    },

    /**
     * Выделяет закладку по имени.
     *
     * @private
     * @method WebAccess.current#_selectCardTab
     * @param {string} tabName Имя выделяемой закладки.
     */
    _selectCardTab(tabName) {
      WA.CR.sideBar.tabs.toArray().forEach(function (tab) {
        tab.unSelect();
      });
      WA.CR.sideBar.tabs[ tabName ].select();
      WA.CR.sideBar.fire(WA.CR.sideBar.class.EVENT.AFTER_TAB_SWITCH);
    },
  });

  global.current = global.CR = new Current();

})(window.WA);
